import { I18n } from "@assets/strings";
import React, { useState } from "react";
import styled from "styled-components";
import createLiveLogo from "@assets/images/live/create_live_logo.svg";
import { Group } from "@domain/group/group";
import { useIsMobile } from "@utils/hooks";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { Menu } from "@ui/components/menus/menu";
import { useModalTools } from "@ui/modals/modalContext";
import { gap } from "@ui/styles/utils";
import {
	GroupLivecoursesChooserModal,
	GroupLivecoursesMobileModal,
	OrganizationLivecoursesChooserModal,
	OrganizationLivecoursesMobileModal,
} from "./livecoursesChooserModal";
import { LivesLimitModal } from "./livesLimitModal";

interface CreateGrouplivecoursesThumbnailProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
	limitReached?: boolean;
}

interface CreateOrganizationlivecoursesThumbnailProps extends React.HTMLAttributes<HTMLDivElement> {
	organizationId: string;
	limitReached?: boolean;
}

export const CreateGrouplivecoursesThumbnail: React.FC<CreateGrouplivecoursesThumbnailProps> = ({
	shareroom,
	limitReached,
	...htmlProps
}) => {
	const [liveChooserMobile, setLiveChooserMobile] = useState(false);
	const { createModal } = useModalTools();
	const isMobile = useIsMobile();
	return (
		<>
			<Cell {...htmlProps}>
				<CellContent>
					<img src={createLiveLogo} width={137} height={88} />

					<TextDescription>{I18n.t("live.description")}</TextDescription>
					<PrimaryButton
						onClick={() =>
							!isMobile
								? createModal((close) =>
										limitReached ? (
											<LivesLimitModal close={close} />
										) : (
											<GroupLivecoursesChooserModal close={close} shareroom={shareroom} />
										)
									)
								: setLiveChooserMobile(true)
						}
					>
						{I18n.t("live.create")}
					</PrimaryButton>
				</CellContent>
			</Cell>
			{liveChooserMobile && (
				<StyledMenu
					renderMenuContent={() => <GroupLivecoursesMobileModal shareroom={shareroom} />}
					closeOnSelect
					bottomSheetMode={isMobile}
					manualOpen={liveChooserMobile}
					onOpenChange={(opened: boolean) => {
						setLiveChooserMobile(opened);
					}}
				/>
			)}
		</>
	);
};

export const CreateOrganizationlivecoursesThumbnail: React.FC<CreateOrganizationlivecoursesThumbnailProps> = ({
	organizationId,
	limitReached,
	...htmlProps
}) => {
	const [liveChooserMobile, setLiveChooserMobile] = useState(false);
	const { createModal } = useModalTools();
	const isMobile = useIsMobile();

	return (
		<>
			<CellOrg {...htmlProps}>
				<CellContent>
					<img src={createLiveLogo} width={137} height={88} />

					<TextDescription>{I18n.t("live.description")}</TextDescription>
					<PrimaryButton
						onClick={() =>
							!isMobile
								? createModal((close) =>
										limitReached ? (
											<LivesLimitModal close={close} />
										) : (
											<OrganizationLivecoursesChooserModal close={close} organizationId={organizationId} />
										)
									)
								: setLiveChooserMobile(true)
						}
					>
						{I18n.t("live.create")}
					</PrimaryButton>
				</CellContent>
			</CellOrg>
			{liveChooserMobile && (
				<StyledMenu
					renderMenuContent={() => <OrganizationLivecoursesMobileModal organizationId={organizationId} />}
					closeOnSelect
					bottomSheetMode={isMobile}
					manualOpen={liveChooserMobile}
					onOpenChange={(opened: boolean) => {
						setLiveChooserMobile(opened);
					}}
				/>
			)}
		</>
	);
};

const Cell = styled.div`
	display: flex;
	 {
		flex: 1;
		display: flex;
	}
	font-size: 12px;
	font-weight: 400;
	text-align: center;
	text-color: #5d5d5d;
	width: 100%;
	height: 389px;
`;

const CellOrg = styled.div`
	display: flex;
	 {
		flex: 1;
		display: flex;
	}
	font-size: 12px;
	font-weight: 400;
	text-align: center;
	text-color: #5d5d5d;
	width: 100%;
	height: 389px;
`;

const CellContent = styled(RoundedBlock)`
	display: flex;
	flex: 1;
	flex-direction: column;
	align-items: center;
	padding: 40px 60px 0px;
	${gap(40)}
`;

const TextDescription = styled.div`
	position: relative;
	font-family: Sora;
	color: #5d5d5d;
	font-size: 16px;
	font-weight: 100;
`;

const StyledMenu = styled(Menu)`
	${({ theme }) => theme.textStyles.primary};
	color: ${({ theme }) => theme.colors.secondary};
`;
